import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { DeleteMyJOurnalRecordsRequest, FetchDailyScreenActivityRequest } from '../../core/my-journal.actions';
import { GetDailyScreenTime } from '../../core/my-journal.selector';
import { AddDailyScreenTimeComponent } from '../add-daily-screen-time/add-daily-screen-time.component';

@Component({
  selector: 'app-screen-time-tracker',
  templateUrl: './screen-time-tracker.component.html',
  styleUrls: ['./screen-time-tracker.component.css']
})
export class ScreenTimeTrackerComponent {

  @Input() selectedDate;
  @Input() memberId;
  @Input() groupId;
  expandPanel: any = true;
  dataSource = []
  loading: boolean = false;


  colDef = [
    'dayTime',
    'screenType',
    'activity',
    'time',
    'comments',
    'actions'
  ]
  totalSt;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private commonService: CommonService, private store: Store) { }

  ngOnInit() {
    this.store.dispatch(FetchDailyScreenActivityRequest())
    this.store.select(GetDailyScreenTime).pipe(takeUntil(this.onDestroy)).subscribe(screen => {
      this.loading = screen.loading;
      this.dataSource = screen.list;
      this.totalSt = screen.totalSt
    })
  }

  addDailyScreenTime() {
    this.commonService.openDialog({
      data: {
        component: AddDailyScreenTimeComponent,
        data: { memberId: this.memberId, selectedDate: this.selectedDate, groupId: this.groupId }
      }
    });
  }

  onEditClicked(data:any){
    const addFood = this.commonService.openDialog({
      data: {
        component: AddDailyScreenTimeComponent,
        data: { memberId: this.memberId, selectedDate: this.selectedDate, groupId: this.groupId },
        previousData:data
      }
    })
  }

  onDeleteRecord(data) {
    this.store.dispatch(DeleteMyJOurnalRecordsRequest({
      payload: {
        ...(this.memberId ? { memberId: this.memberId } : {}),
        selectedDate: this.selectedDate,
        recordId: data.id,
        recordType: 3
      }
    }))
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
